<nz-modal nzCentered [nzMaskClosable]="false" class="custom-modal vivek" [(nzVisible)]="isVisible"
    [nzTitle]="'Audit Log(s)'" [nzWidth]="1000" [nzFooter]="null" nzOkText="Save" nzCancelText="Cancel"
    (nzOnCancel)="handleCancel()">
    <ng-container *nzModalContent class="custom-modal">
        <div class="modal-height ">
            <strong class="stock-name"  *ngIf="entityType != entityTypes.warehouse">{{entityType == entityTypes.Stock ? 'Stock ' + entityDetails?.name :(entityType
                ==
                entityTypes.Assignment ? 'Assignment of ' + entityDetails?.invoiceNo : 'Status of ' +
                entityDetails?.invoiceNo)}}</strong>
                <strong class="stock-name">{{entityType == entityTypes.warehouse ? 'Warehouse ' + entityDetails?.partNumber : entityDetails?.partNumber }}</strong>
                <!-- 
                <strong class="stock-name" *ngIf="entityTypes.Assignment == null ? false : true">{{entityType == entityTypes.Assignment ? 'Assignment of ' + entityDetails?.invoiceNo : entityDetails?.invoiceNo }}</strong>
                <strong class="stock-name" *ngIf="entityTypes.Stock == null ? false : true">{{entityType == entityTypes.Stock ? 'Stock ' + entityDetails?.name : entityDetails?.invoiceNo }}</strong>
                <strong class="stock-name" *ngIf="entityTypes.Status == null ? false : true">{{entityType == entityTypes.Status ? 'Status of ' + entityDetails?.invoiceNo : entityDetails?.invoiceNo }}</strong> -->
       

            <nz-list class="history-modal" [nzDataSource]="lst_AuditLog" [nzRenderItem]="item"
                [nzItemLayout]="'horizontal'">
                <ng-template #item let-item>
                    <nz-comment [nzAuthor]="item.author" [nzDatetime]="item.datetime">
                        <nz-comment-content>
                            <div class="user-img">
                                <div class="centered">{{item?.createdBy?.substring(0,1)}}</div>
                            </div>
                            <div class="user-detail-box">
                                <p class="history-title-text">{{ item.title }}</p>
                                <p class="history-text">{{item.note}}</p>
                                <p class="last-update-text">Last Updated by {{item.createdBy}} on <span>{{item.createdOn
                                        | date : 'MM/dd/yyyy - hh:mm a' : 'UTC'}} </span> </p>
                            </div>
                        </nz-comment-content>
                    </nz-comment>
                </ng-template>
            </nz-list>
        </div>
    </ng-container>
</nz-modal>